import {
	FunctionComponent, PropsWithChildren, useCallback, useState,
} from 'react';
import Marquee from 'react-fast-marquee';

const MARQUEE_TIME_BREAK = 10000; // 10s

export const MarqueeWrapper: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => {
	const [marqueeKey, setMarqueeKey] = useState(0);
	const [isPlaying, setIsPlaying] = useState(true);

	const reset = useCallback(() => {
		setIsPlaying(true);
		setMarqueeKey((key) => key + 1);
	}, []);

	const onFinish = useCallback(() => {
		setIsPlaying(false);
		setTimeout(() => {
			reset();
		}, MARQUEE_TIME_BREAK);
	}, [reset]);

	return (
		<Marquee
			key={marqueeKey}
			gradientWidth={10}
			gradient={isPlaying}
			loop={1}
			onFinish={onFinish}
		>
			{ children }
		</Marquee>
	);
};
